.overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: max(var(--tempest-space-4), var(--tempest-safe-area-top))
        max(var(--tempest-space-4), var(--tempest-safe-area-right))
        max(var(--tempest-space-4), var(--tempest-safe-area-bottom))
        max(var(--tempest-space-4), var(--tempest-safe-area-left));
    z-index: var(--tempest-z-modal);
    animation: tempest-fade-in var(--tempest-duration-base) var(--tempest-ease-out);
}

.dialog {
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    border-radius: var(--tempest-radius-xl);
    box-shadow: var(--tempest-shadow-xl);
    width: 100%;
    max-height: 90vh;
    max-height: 90dvh;
    display: flex;
    flex-direction: column;
    animation: tempest-modal-in var(--tempest-duration-base) var(--tempest-ease-emphasized);
}

.sm {
    max-width: 400px;
}
.md {
    max-width: 560px;
}
.lg {
    max-width: 800px;
}
.xl {
    max-width: 1024px;
}
.size2xl {
    max-width: 1280px;
}
.size3xl {
    max-width: 1440px;
}

/* Fullscreen — fill entire viewport regardless of size. */
.fullscreen {
    max-width: 100%;
    max-height: 100vh;
    max-height: 100dvh;
    width: 100%;
    height: 100%;
    border-radius: 0;
}

/* Auto-fullscreen below mobile breakpoint. */
@media (max-width: 639.98px) {
    .fullscreenOnMobile {
        max-width: 100%;
        max-height: 100vh;
        max-height: 100dvh;
        width: 100%;
        height: 100%;
        border-radius: 0;
    }
}

/* Mobile padding adjustment for non-fullscreen modals. */
@media (max-width: 639.98px) {
    .dialog:not(.fullscreen):not(.fullscreenOnMobile) {
        border-radius: var(--tempest-radius-lg);
    }
    .body {
        padding: var(--tempest-space-4);
    }
    .header,
    .footer {
        padding: var(--tempest-space-3) var(--tempest-space-4);
    }
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-4) var(--tempest-space-5);
    border-bottom: 1px solid var(--tempest-border);
}

.title {
    margin: 0;
    font-size: var(--tempest-text-lg);
    font-weight: var(--tempest-weight-semibold);
    line-height: var(--tempest-leading-snug);
    color: var(--tempest-text);
}

.close {
    background: none;
    border: none;
    color: var(--tempest-text-muted);
    padding: var(--tempest-space-1);
    border-radius: var(--tempest-radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .close:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-text);
    }
}

.close:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.body {
    padding: var(--tempest-space-5);
    overflow-y: auto;
    line-height: var(--tempest-leading-normal);
}

.footer {
    display: flex;
    justify-content: flex-end;
    gap: var(--tempest-space-2);
    padding: var(--tempest-space-4) var(--tempest-space-5);
    border-top: 1px solid var(--tempest-border);
    background-color: var(--tempest-surface);
    border-radius: 0 0 var(--tempest-radius-xl) var(--tempest-radius-xl);
}

@keyframes tempest-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes tempest-modal-in {
    from {
        opacity: 0;
        transform: translateY(12px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .overlay,
    .dialog {
        animation: none;
    }
}
